import React, { FC } from "react"

export type Props = {
  header: { name: string; width: string }[]
  children: JSX.Element | JSX.Element[]
  headerAlign: "text-left" | "text-center" | "text-right"
  lastheadingAlign: "text-left" | "text-center" | "text-right"
  tableClassName?: string
}

export const Table: FC<Props> = (props) => {
  return (
    <div className="table-container dark:text-primary-10 text-light-2 rounded-lg">
      <div className="relative table_wrap rounded-lg">
        <table className={`w-full fixed_header ${props.tableClassName || ""}`}>
          <thead className="sticky top-0">
            <tr
              className={
                props.headerAlign + " dark:bg-secondary-2 bg-primary-11"
              }
            >
              {props.header.map((e, i) => (
                <th
                  key={i}
                  className={
                    ((props.header.length - 1 == i &&
                      `${props.lastheadingAlign} rounded-tr-lg`) ||
                      (i == 0 && "rounded-tl-lg")) +
                    ` ${e.width} whitespace-nowrap p-4 font-medium dark:text-white text-white`
                  }
                >
                  {e.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="dark:bg-primary-1 bg-white text-sm whitespace-nowrap divide-y dark:divide-secondary-11">
            {props.children}
          </tbody>
        </table>
      </div>
    </div>
  )
}
